const Bro = () => {
    return (
        <svg width="280" height="276" viewBox="0 0 280 276" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M267.925 210.727H224.492V216.809H267.925V210.727Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M220.428 207.891H214.684V215.385H220.428V207.891Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M246.647 207.891H240.902V215.385H246.647V207.891Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M272.227 218.629H210.684V252.097H272.227V218.629Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M272.239 218.629H249.645V252.097H272.239V218.629Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M273.614 214.219H209.305V220.302H273.614V214.219Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M273.614 252.098H209.305V255.139H273.614V252.098Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M219.675 226.121H213.68V227.871H219.675V226.121Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M246.897 226.121H240.902V227.871H246.897V226.121Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M244.773 229.991V223.996H243.024V229.991H244.773Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M192.009 221.863H106.949C105.719 221.863 104.723 222.86 104.723 224.089V252.221C104.723 253.451 105.719 254.448 106.949 254.448H192.009C193.239 254.448 194.235 253.451 194.235 252.221V224.089C194.235 222.86 193.239 221.863 192.009 221.863Z"
                fill="#878787"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M180.815 221.871L148.237 254.449H104.635C104.342 254.45 104.052 254.393 103.781 254.281C103.51 254.17 103.264 254.006 103.057 253.799C102.849 253.592 102.685 253.347 102.572 253.076C102.46 252.806 102.402 252.516 102.402 252.223V224.097C102.402 223.804 102.46 223.514 102.572 223.244C102.685 222.973 102.849 222.728 103.057 222.521C103.264 222.314 103.51 222.15 103.781 222.039C104.052 221.927 104.342 221.87 104.635 221.871H180.815Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M191.921 230.348V252.221C191.921 252.811 191.687 253.378 191.269 253.795C190.852 254.213 190.286 254.447 189.695 254.447H167.828L191.921 230.348Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M188.985 225.395V251.2H143.57L142.335 249.168H114.667L113.432 251.2H105.336V225.395H113.194L114.667 227.828H142.335L143.809 225.395H188.985Z"
                fill="#878787"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M141.083 233.652H116.469V243.159H141.083V233.652Z"
                fill="#878787"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M142.337 249.168L143.572 251.2H113.434L114.669 249.168H142.337Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M114.669 227.828L113.195 225.395H143.81L142.337 227.828H114.669Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M128.5 247.011C133.31 247.011 137.21 243.111 137.21 238.3C137.21 233.49 133.31 229.59 128.5 229.59C123.689 229.59 119.789 233.49 119.789 238.3C119.789 243.111 123.689 247.011 128.5 247.011Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M130.101 245.09C133.857 244.208 136.187 240.447 135.305 236.691C134.422 232.936 130.662 230.606 126.906 231.488C123.15 232.371 120.821 236.131 121.703 239.887C122.585 243.643 126.346 245.972 130.101 245.09Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M142.335 249.168H114.667L113.413 251.2H143.552L142.335 249.168ZM113.188 225.395L114.661 227.828H142.329L143.803 225.395H113.188Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M186.1 232.094H142.535V244.46H186.1V232.094Z"
                fill="#878787"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path d="M145.477 232.387V235.039" stroke="#263238" strokeWidth="0.0492781" strokeMiterlimit="10" />
            <path d="M150.336 232.387V235.039" stroke="#263238" strokeWidth="0.0492781" strokeMiterlimit="10" />
            <path d="M155.191 232.387V235.039" stroke="#263238" strokeWidth="0.0492781" strokeMiterlimit="10" />
            <path d="M160.051 232.387V235.039" stroke="#263238" strokeWidth="0.0492781" strokeMiterlimit="10" />
            <path d="M164.906 232.387V235.039" stroke="#263238" strokeWidth="0.0492781" strokeMiterlimit="10" />
            <path d="M169.766 232.387V235.039" stroke="#263238" strokeWidth="0.0492781" strokeMiterlimit="10" />
            <path d="M174.625 232.387V235.039" stroke="#263238" strokeWidth="0.0492781" strokeMiterlimit="10" />
            <path d="M179.477 232.387V235.039" stroke="#263238" strokeWidth="0.0492781" strokeMiterlimit="10" />
            <path d="M184.34 232.387V235.039" stroke="#263238" strokeWidth="0.0492781" strokeMiterlimit="10" />
            <path d="M145.477 241.66V244.307" stroke="#263238" strokeWidth="0.0492781" strokeMiterlimit="10" />
            <path d="M150.336 241.66V244.307" stroke="#263238" strokeWidth="0.0492781" strokeMiterlimit="10" />
            <path d="M155.191 241.66V244.307" stroke="#263238" strokeWidth="0.0492781" strokeMiterlimit="10" />
            <path d="M160.051 241.66V244.307" stroke="#263238" strokeWidth="0.0492781" strokeMiterlimit="10" />
            <path d="M164.906 241.66V244.307" stroke="#263238" strokeWidth="0.0492781" strokeMiterlimit="10" />
            <path d="M169.766 241.66V244.307" stroke="#263238" strokeWidth="0.0492781" strokeMiterlimit="10" />
            <path d="M174.625 241.66V244.307" stroke="#263238" strokeWidth="0.0492781" strokeMiterlimit="10" />
            <path d="M179.477 241.66V244.307" stroke="#263238" strokeWidth="0.0492781" strokeMiterlimit="10" />
            <path d="M184.34 241.66V244.307" stroke="#263238" strokeWidth="0.0492781" strokeMiterlimit="10" />
            <path
                d="M107.344 230.266V234.555L115.12 235.057V231.984L107.344 230.266Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M107.344 245.698V241.415L115.12 240.387V243.986L107.344 245.698Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M115.281 239.171L107.109 240.475V235.734L115.281 236.412V239.171Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M184.713 229.208C185.357 229.208 185.88 228.686 185.88 228.041C185.88 227.397 185.357 226.875 184.713 226.875C184.069 226.875 183.547 227.397 183.547 228.041C183.547 228.686 184.069 229.208 184.713 229.208Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M189.963 221.863H104.445C103.215 221.863 102.219 222.86 102.219 224.089V252.221C102.219 253.451 103.215 254.448 104.445 254.448H189.963C191.192 254.448 192.189 253.451 192.189 252.221V224.089C192.189 222.86 191.192 221.863 189.963 221.863Z"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M26.0148 259.541C39.5151 259.541 50.4592 248.597 50.4592 235.097C50.4592 221.597 39.5151 210.652 26.0148 210.652C12.5145 210.652 1.57031 221.597 1.57031 235.097C1.57031 248.597 12.5145 259.541 26.0148 259.541Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M24.9405 259.541C38.4408 259.541 49.385 248.597 49.385 235.097C49.385 221.597 38.4408 210.652 24.9405 210.652C11.4402 210.652 0.496094 221.597 0.496094 235.097C0.496094 248.597 11.4402 259.541 24.9405 259.541Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M30.3074 253.85C40.6613 250.881 46.648 240.08 43.6791 229.726C40.7101 219.373 29.9099 213.386 19.556 216.355C9.20208 219.324 3.21539 230.124 6.18432 240.478C9.15325 250.832 19.9535 256.818 30.3074 253.85Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M24.9429 239.491C27.3707 239.491 29.3389 237.523 29.3389 235.095C29.3389 232.667 27.3707 230.699 24.9429 230.699C22.515 230.699 20.5469 232.667 20.5469 235.095C20.5469 237.523 22.515 239.491 24.9429 239.491Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M27.7706 235.099C27.7718 234.537 27.6065 233.989 27.2955 233.521C26.9845 233.054 26.5419 232.69 26.0237 232.475C25.5055 232.259 24.935 232.203 24.3846 232.312C23.8342 232.421 23.3286 232.691 22.9318 233.088C22.535 233.485 22.2649 233.99 22.1557 234.541C22.0466 235.091 22.1032 235.662 22.3185 236.18C22.5338 236.698 22.8981 237.141 23.3652 237.452C23.8323 237.763 24.3812 237.928 24.9423 237.927C25.6924 237.927 26.4118 237.629 26.9422 237.098C27.4726 236.568 27.7706 235.849 27.7706 235.099Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path d="M24.9414 232.262V237.924" stroke="#263238" strokeWidth="0.0492781" strokeMiterlimit="10" />
            <path d="M22.1055 235.098H27.7682" stroke="#263238" strokeWidth="0.0492781" strokeMiterlimit="10" />
            <path
                d="M60.0226 259.541C73.5229 259.541 84.467 248.597 84.467 235.097C84.467 221.597 73.5229 210.652 60.0226 210.652C46.5223 210.652 35.5781 221.597 35.5781 235.097C35.5781 248.597 46.5223 259.541 60.0226 259.541Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M58.9484 259.541C72.4487 259.541 83.3928 248.597 83.3928 235.097C83.3928 221.597 72.4487 210.652 58.9484 210.652C45.4481 210.652 34.5039 221.597 34.5039 235.097C34.5039 248.597 45.4481 259.541 58.9484 259.541Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M72.743 248.892C80.3593 241.276 80.3593 228.927 72.743 221.311C65.1266 213.695 52.7781 213.695 45.1617 221.311C37.5454 228.927 37.5454 241.276 45.1617 248.892C52.7781 256.509 65.1266 256.509 72.743 248.892Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M58.9507 239.491C61.3785 239.491 63.3467 237.523 63.3467 235.095C63.3467 232.667 61.3785 230.699 58.9507 230.699C56.5228 230.699 54.5547 232.667 54.5547 235.095C54.5547 237.523 56.5228 239.491 58.9507 239.491Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M61.7667 235.099C61.7679 234.538 61.6027 233.989 61.292 233.522C60.9813 233.055 60.539 232.691 60.0212 232.475C59.5034 232.26 58.9333 232.203 58.383 232.312C57.8328 232.42 57.3271 232.69 56.9301 233.086C56.533 233.482 56.2625 233.987 56.1526 234.537C56.0427 235.087 56.0985 235.657 56.3128 236.176C56.5272 236.694 56.8905 237.137 57.3567 237.449C57.823 237.76 58.3713 237.927 58.9322 237.927C59.6828 237.927 60.4028 237.629 60.9342 237.099C61.4656 236.569 61.765 235.849 61.7667 235.099Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path d="M58.9492 232.262V237.924" stroke="#263238" strokeWidth="0.0492781" strokeMiterlimit="10" />
            <path d="M56.1211 235.098H61.7838" stroke="#263238" strokeWidth="0.0492781" strokeMiterlimit="10" />
            <path
                d="M253.776 183.982C254.021 176.418 205.481 168.712 145.36 166.771C85.2394 164.829 36.3038 169.386 36.0595 176.949C35.8152 184.513 84.3547 192.219 144.476 194.161C204.596 196.103 253.532 191.545 253.776 183.982Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M38.8084 156.958C38.8084 156.958 40.1316 159.824 41.0785 160.802C42.0255 161.781 59.1015 166.007 59.1015 166.007L114.443 178.123L121.147 177.402L144.582 178.154C144.582 178.154 149.26 166.716 144.155 155.447C139.051 144.178 113.515 139.769 106.297 142.065C99.0792 144.36 82.1726 151.747 70.0256 147.709C57.8786 143.67 48.1899 135.737 44.1388 136.791C40.0877 137.844 38.1562 144.366 38.1562 147.182C38.1562 149.998 38.8084 156.958 38.8084 156.958Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M157.768 172.629C157.285 160.997 149.503 151.552 140.391 151.527H130.508L130.683 155.691C126.82 159.523 124.475 165.643 124.757 172.542C125.039 179.44 127.893 185.579 132.082 189.429L132.257 193.65H142.134C151.252 193.669 158.251 184.262 157.768 172.629Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M133.712 193.558C142.748 192.557 149.033 182.353 147.75 170.766C146.466 159.179 138.101 150.597 129.065 151.598C120.028 152.599 113.743 162.803 115.027 174.39C116.31 185.977 124.676 194.559 133.712 193.558Z"
                fill="#878787"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M144.152 179.752C144.309 179.232 144.453 178.698 144.573 178.153C144.69 177.601 144.79 177.043 144.874 176.479C145.043 175.2 145.102 173.91 145.049 172.622C144.951 169.916 144.354 167.252 143.287 164.764L143.256 164.702C143.03 164.181 142.779 163.673 142.509 163.184L142.459 163.09C142.19 162.607 141.907 162.137 141.606 161.685L141.556 161.61C138.885 157.678 134.965 155.151 130.682 155.145C127.014 155.145 123.784 156.969 121.439 159.961C121.282 160.155 121.131 160.362 120.987 160.588C120.843 160.795 120.699 161.008 120.561 161.215C120.423 161.428 120.291 161.648 120.166 161.842C120.04 162.061 119.921 162.281 119.808 162.507V162.544C119.695 162.764 119.589 162.983 119.482 163.215V163.266C119.382 163.485 119.288 163.711 119.194 163.937C119.194 163.937 119.194 163.987 119.162 164.018C119.075 164.238 118.993 164.457 118.911 164.683L118.874 164.789C118.799 165.003 118.73 165.222 118.661 165.448C118.661 165.492 118.629 165.536 118.617 165.58C118.554 165.793 118.498 166.012 118.435 166.207C118.423 166.264 118.409 166.32 118.391 166.376C118.341 166.583 118.291 166.796 118.247 167.003C118.247 167.066 118.215 167.135 118.203 167.197C118.159 167.404 118.121 167.611 118.084 167.825L118.046 168.057C118.008 168.251 117.983 168.458 117.958 168.684L117.921 168.941C117.921 169.135 117.877 169.336 117.858 169.537C117.858 169.631 117.858 169.725 117.858 169.819C117.858 170.013 117.858 170.214 117.82 170.408V170.709C117.82 170.916 117.82 171.129 117.82 171.336C117.82 171.43 117.82 171.518 117.82 171.606C117.82 171.907 117.82 172.233 117.82 172.522C117.82 172.81 117.858 173.255 117.896 173.619C117.896 173.707 117.896 173.795 117.896 173.882C117.927 174.196 117.965 174.509 118.008 174.817V174.961C118.128 175.726 118.284 176.472 118.472 177.206C119.296 180.634 121.044 183.771 123.527 186.274L123.615 186.355C123.903 186.631 124.198 186.888 124.505 187.139L124.568 187.183C126.68 188.957 129.336 189.953 132.093 190.005C134.804 189.99 137.416 188.989 139.443 187.189C141.672 185.195 143.303 182.62 144.152 179.752Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M143.491 173.149C143.412 171.193 143.023 169.263 142.337 167.43L136.906 170.835C137.153 171.579 137.295 172.353 137.326 173.136C137.326 173.255 137.326 173.368 137.326 173.481L143.497 174.485C143.51 174.046 143.51 173.6 143.491 173.149Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M133.883 166.909C134.465 167.234 134.985 167.658 135.419 168.163L139.245 162.281C137.987 160.868 136.408 159.778 134.642 159.102L133.883 166.909Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M136.547 176.969C136.283 177.505 135.941 178 135.531 178.436L138.667 185.466C140.245 184.106 141.471 182.385 142.241 180.449L136.547 176.969Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M127.31 169.483L121.772 165.633C120.919 167.654 120.469 169.823 120.449 172.017L126.639 172.192C126.694 171.256 126.921 170.337 127.31 169.483Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M129.19 167.137C129.638 166.824 130.139 166.594 130.67 166.46L129.767 158.684C127.79 159.05 125.976 160.021 124.574 161.462L129.19 167.137Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M132.839 179.884C132.644 179.909 132.447 179.922 132.25 179.921C131.691 179.92 131.138 179.811 130.619 179.602L127.609 186.33C129.112 187.245 130.835 187.735 132.595 187.748C133.071 187.75 133.547 187.715 134.018 187.641L132.839 179.884Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M127.267 176.035L121.141 177.402C121.733 179.546 122.75 181.548 124.132 183.291L128.058 177.49C127.74 177.036 127.475 176.548 127.267 176.035Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M65.0885 160.872C64.8628 151.127 61.213 143.206 56.9362 143.188H47.0781L47.8996 178.481H57.7577C62.0345 178.5 65.3143 170.598 65.0885 160.872Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M55.2324 160.872C55.4582 170.617 52.1784 178.5 47.9016 178.481C43.6248 178.462 39.975 170.548 39.7493 160.797C39.5235 151.045 42.8033 143.169 47.0801 143.188C51.3569 143.206 55.0067 151.158 55.2324 160.872Z"
                fill="#878787"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M53.4821 166.837C53.5573 166.398 53.6263 165.953 53.6828 165.495C53.7392 165.037 53.7831 164.567 53.8207 164.09C53.896 163.049 53.9273 161.971 53.9022 160.861C53.8607 158.642 53.579 156.434 53.0619 154.276V154.226C52.9553 153.787 52.8362 153.361 52.7107 152.972V152.89C52.5791 152.489 52.4474 152.094 52.3031 151.718V151.655C51.0489 148.356 49.2115 146.243 47.1985 146.23C45.4803 146.23 43.9564 147.761 42.8652 150.269C42.79 150.438 42.721 150.608 42.652 150.777C42.583 150.953 42.5141 151.128 42.4514 151.31C42.3886 151.492 42.3259 151.674 42.2695 151.856C42.2131 152.037 42.1566 152.219 42.1002 152.414C42.0416 152.598 41.9915 152.786 41.9497 152.978V153.022C41.8995 153.204 41.8556 153.392 41.8117 153.586C41.8146 153.607 41.8146 153.628 41.8117 153.649C41.7678 153.831 41.7302 154.019 41.6926 154.207C41.6899 154.236 41.6899 154.266 41.6926 154.295C41.6549 154.477 41.6236 154.665 41.586 154.847V154.96C41.586 155.142 41.5295 155.323 41.5044 155.505V155.643C41.5044 155.819 41.4543 155.994 41.4355 156.17C41.4324 156.226 41.4324 156.283 41.4355 156.339C41.4355 156.509 41.3978 156.684 41.3853 156.854C41.3853 156.923 41.3853 156.985 41.3853 157.048L41.3477 157.556V157.769C41.3477 157.938 41.3477 158.102 41.3477 158.271C41.3477 158.44 41.3477 158.428 41.3477 158.503C41.3477 158.672 41.3477 158.835 41.3477 159.005C41.3477 159.174 41.3477 159.168 41.3477 159.249C41.3477 159.425 41.3477 159.6 41.3477 159.782C41.3477 159.857 41.3477 159.933 41.3477 160.008C41.3477 160.259 41.3477 160.516 41.3477 160.767C41.3477 161.018 41.3477 161.394 41.3477 161.695C41.3477 161.764 41.3477 161.839 41.3477 161.914L41.4041 162.692C41.4041 162.736 41.4041 162.773 41.4041 162.817C41.4605 163.444 41.5358 164.072 41.6236 164.699C41.9478 167.355 42.7622 169.928 44.0254 172.287L44.063 172.362C44.201 172.588 44.3389 172.807 44.4832 172.989V173.027C45.5179 174.513 46.7345 175.384 48.02 175.391C49.3056 175.397 50.4908 174.525 51.4628 173.033C52.5281 171.117 53.2137 169.013 53.4821 166.837Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M252.937 165.887C252.454 154.254 244.672 144.81 235.56 144.785H225.677C216.559 144.785 209.56 154.192 210.043 165.806C210.526 177.42 218.308 186.901 227.426 186.901H237.303C246.421 186.933 253.42 177.495 252.937 165.887Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M68.2477 93.2902C68.2477 93.2902 63.858 94.582 63.2748 95.8676C62.6916 97.1532 62.3592 98.075 62.3592 98.075L49.1085 117.396C49.1085 117.396 44.3238 117.032 42.8375 121.077C41.3513 125.122 41.9219 130.647 41.9219 130.647C41.9219 130.647 38.4227 139.294 38.2409 145.735C38.1161 149.485 38.3007 153.24 38.7927 156.96C38.7927 156.96 37.8709 145.183 40.6301 141.502C43.3894 137.821 49.096 140.586 51.2909 147.208C53.4857 153.831 56.1195 166.16 56.1195 166.16L114.44 178.125C114.44 178.125 111.493 162.667 115.362 153.831C119.231 144.995 137.254 145.553 140.571 161.563C143.889 177.573 142.779 180.514 142.779 180.514C142.779 180.514 155.108 183.091 192.646 182.539C230.184 181.988 250.791 177.573 256.316 176.099C256.316 176.099 257.57 169.289 257.971 165.244C258.215 162.916 257.834 160.565 256.868 158.434C256.868 158.434 256.498 151.071 255.576 148.494C254.654 145.917 251.895 142.054 251.895 142.054C251.895 142.054 249.135 135.613 244.539 131.569C239.942 127.524 232.392 123.473 230.548 122.551C228.704 121.629 226.321 121.077 222.822 118.688C219.323 116.299 197.613 101.204 190.802 97.1594C183.992 93.1146 169.274 91.0828 166.345 90.531C163.417 89.9791 129.541 87.5898 117.764 87.5898C105.987 87.5898 81.6802 88.1417 68.2477 93.2902Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                opacity="0.15"
                d="M257.968 165.241C258.212 162.913 257.831 160.562 256.864 158.431C256.864 158.431 256.745 156.073 256.475 153.564C233.448 160.356 192.254 160.813 180.765 159.798C167.565 158.637 144.149 155.445 143.139 151.645C142.13 147.845 133.049 139.222 126.835 136.89C121.51 134.895 59.7346 126.342 42.1758 123.934C41.8532 126.153 41.7838 128.402 41.9688 130.637C41.9688 130.637 38.4696 139.285 38.2877 145.725C38.163 149.476 38.3476 153.23 38.8396 156.951C38.8396 156.951 37.9177 145.174 40.677 141.492C43.4362 137.811 49.1429 140.577 51.3377 147.199C53.5326 153.821 56.1225 166.156 56.1225 166.156L114.443 178.122C114.443 178.122 111.496 162.663 115.365 153.828C119.234 144.992 137.257 145.55 140.574 161.56C143.892 177.57 142.782 180.511 142.782 180.511C142.782 180.511 155.111 183.088 192.649 182.536C230.187 181.984 250.794 177.57 256.319 176.096C256.312 176.096 257.598 169.286 257.968 165.241Z"
                fill="black"
            />
            <path
                d="M108.546 99.1791C101.14 93.8738 94.7501 93.0649 91.7526 92.8203C88.8993 97.9437 84.2274 107.639 83.293 117.691C98.9705 120.137 116.46 122.921 116.46 122.921C116.46 122.921 120.505 124.389 121.979 122.921C122.462 122.528 122.841 122.022 123.083 121.448C123.453 120.526 117.012 105.256 108.546 99.1791Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M86.7185 92.8359C82.4927 93.0628 78.2886 93.593 74.1388 94.4225C69.9059 95.3443 68.4322 95.5262 67.6985 96.2662C66.9647 97.0062 59.7844 106.005 57.207 112.427C57.3128 112.888 57.5693 113.302 57.9361 113.602C58.3028 113.901 58.759 114.07 59.2326 114.082C59.8597 114.082 67.5605 115.249 77.1552 116.735C78.7605 111.022 81.9838 100.988 86.7185 92.8359Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M63.3398 114.372C63.3398 114.372 66.4754 102.288 72.8091 95.1016"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M83.4639 126.373L78.2276 125.445C78.0573 125.496 77.8988 125.58 77.7613 125.693C77.6238 125.806 77.51 125.944 77.4266 126.101C77.3431 126.258 77.2917 126.43 77.2753 126.607C77.2588 126.784 77.2777 126.963 77.3308 127.132C77.7196 128.418 78.4157 128.274 78.4157 128.274L82.7741 128.976C83.0602 129.005 83.347 128.927 83.5787 128.757C83.8105 128.586 83.9707 128.336 84.0283 128.054C84.2541 127.001 84.5488 126.869 83.4639 126.373Z"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M56.9914 121.811L52.9842 121.059C52.7125 121.151 52.4884 121.348 52.3604 121.605C52.2324 121.862 52.211 122.159 52.3007 122.432C52.5954 123.473 53.1285 123.36 53.1285 123.36L56.4584 123.931C56.6843 123.952 56.91 123.886 57.0886 123.746C57.2672 123.606 57.3851 123.403 57.4179 123.178C57.5997 122.313 57.8255 122.219 56.9914 121.811Z"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M89.0138 92.2109C89.0138 92.2109 81.5513 106.089 80.2344 117.609"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M78.5387 119.992C78.5387 119.992 75.1335 125.749 75.0018 127.712C74.8701 129.675 75.2652 153.241 75.9174 157.562"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M115.589 107.16C115.589 107.16 112.967 114.754 112.184 118.812"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M114.543 128.238C114.543 128.238 111.658 137.795 111.533 144.994C111.407 152.194 111.27 165.689 111.27 165.689"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M56.8048 115.012C56.8048 115.012 50.6529 120.656 50.1324 122.474C49.612 124.293 50.2579 140.033 50.2579 140.033"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M58.0039 157.824C58.0039 157.824 58.9195 160.446 60.8823 161.098C62.8451 161.75 110.505 170.918 110.505 170.918"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M196.035 166.134C196.035 166.134 232.526 166.636 246.084 162.453C246.084 162.453 244.748 171.49 242.234 173.333C239.719 175.177 221.477 177.052 212.609 177.347C202.576 177.685 196.869 176.682 196.869 176.682L196.035 166.134Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M189.504 143.363L193.185 150.888C193.185 150.888 213.773 151.39 216.118 151.553C218.463 151.716 220.972 152.895 223.643 151.553C226.315 150.211 237.872 148.712 239.214 148.712C240.556 148.712 242.224 149.885 242.224 149.885C242.224 149.885 239.214 142.36 238.042 141.683C237.163 141.238 236.173 141.061 235.195 141.175C234.699 141.187 210.261 139.35 189.504 143.363Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M150.702 128.332C150.702 128.332 141.923 126.984 138.58 128.163C135.238 129.342 136.893 133.889 142.619 138.096C148.344 142.304 153.06 146.343 158.923 147.02C164.787 147.697 174.946 149.905 175.447 148.023C175.949 146.142 174.099 139.438 167.364 134.553C160.629 129.668 150.702 128.332 150.702 128.332Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M221.049 118.731L219.368 119.239L211.216 119.471C206.933 119.596 201.277 119.753 195.024 119.916C186.395 120.148 176.638 120.386 167.827 120.543C154.357 120.825 143.081 120.97 141.388 120.719C137.986 120.281 134.789 118.845 132.201 116.592C130.252 114.848 128.632 112.769 127.416 110.453C123.422 103.072 113.188 93.9853 113.188 93.9853C129.348 92.104 167.902 92.8064 172.279 92.9757C173.637 93.0449 174.989 93.2084 176.324 93.4648C180.996 94.2926 187.092 96.13 190.628 98.5318C191.255 98.9583 192.265 99.6292 193.532 100.476C196.492 102.451 200.881 105.361 205.29 108.283L212.978 113.369L221.049 118.731Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M190.596 98.5318C191.223 98.9583 192.232 99.6293 193.499 100.476L167.876 120.543C154.406 120.825 143.13 120.97 141.437 120.719C138.034 120.281 134.837 118.845 132.25 116.592L176.291 93.4648C180.963 94.2926 187.059 96.13 190.596 98.5318Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M212.947 113.367L211.266 119.469C206.983 119.594 201.326 119.751 195.074 119.914L205.258 108.281L212.947 113.367Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M184.785 138.328C185.807 139.369 186.798 140.467 187.739 141.633"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M159.957 123.445C159.957 123.445 172.7 127.208 183.016 136.614"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M241.574 141.332C242.92 143.861 243.896 146.571 244.471 149.378"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M222.082 124.125C222.082 124.125 233.37 128.515 240.136 138.9"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M170.06 169.408C170.06 171.365 168.179 172.945 165.852 172.945C163.526 172.945 161.645 171.365 161.645 169.408C161.645 167.451 163.526 165.871 165.852 165.871C168.179 165.871 170.06 167.464 170.06 169.408Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M257.227 163.663C256.87 165.35 255.735 166.535 254.687 166.309C253.64 166.083 253.082 164.547 253.433 162.86C253.784 161.173 254.926 159.994 255.942 160.214C256.957 160.433 257.585 161.982 257.227 163.663Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M112.591 121.056C112.591 121.056 109.098 115.167 106.89 114.785C104.683 114.402 95.2954 114.051 93.2698 115.343C91.2443 116.635 91.8024 120.861 92.5361 121.965C93.2698 123.069 96.2172 123.621 98.8071 123.439C101.397 123.257 110.032 123.991 110.032 123.991C110.032 123.991 115.181 127.672 117.024 127.302C118.868 126.932 121.257 122.912 119.596 120.673C117.934 118.435 115.356 119.049 112.591 121.056Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path d="M112.594 121.074L118.67 122.366" stroke="#263238" strokeWidth="0.0492781" strokeMiterlimit="10" />
            <path
                d="M68.2477 93.2902C68.2477 93.2902 63.858 94.582 63.2748 95.8676C62.6916 97.1532 62.3592 98.075 62.3592 98.075L49.1085 117.396C49.1085 117.396 44.3238 117.032 42.8375 121.077C41.3513 125.122 41.9219 130.647 41.9219 130.647C41.9219 130.647 38.4227 139.294 38.2409 145.735C38.1161 149.485 38.3007 153.24 38.7927 156.96C38.7927 156.96 37.8709 145.183 40.6301 141.502C43.3894 137.821 49.096 140.586 51.2909 147.208C53.4857 153.831 56.1195 166.16 56.1195 166.16L114.44 178.125C114.44 178.125 111.493 162.667 115.362 153.831C119.231 144.995 137.254 145.553 140.571 161.563C143.889 177.573 142.779 180.514 142.779 180.514C142.779 180.514 155.108 183.091 192.646 182.539C230.184 181.988 250.791 177.573 256.316 176.099C256.316 176.099 257.57 169.289 257.971 165.244C258.215 162.916 257.834 160.565 256.868 158.434C256.868 158.434 256.498 151.071 255.576 148.494C254.654 145.917 251.895 142.054 251.895 142.054C251.895 142.054 249.135 135.613 244.539 131.569C239.942 127.524 232.392 123.473 230.548 122.551C228.704 121.629 226.321 121.077 222.822 118.688C219.323 116.299 197.613 101.204 190.802 97.1594C183.992 93.1146 169.274 91.0828 166.345 90.531C163.417 89.9791 129.541 87.5898 117.764 87.5898C105.987 87.5898 81.6802 88.1417 68.2477 93.2902Z"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M237.904 126.812C237.904 126.812 234.204 128.161 235.214 129.509C236.223 130.857 241.779 134.388 244.3 138.765C246.821 143.142 247.336 145.331 248.508 145.331C249.681 145.331 252.239 143.149 251.888 142.051C251.537 140.954 249.687 131.02 237.904 126.812Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M52.6641 160.563C52.6314 158.852 52.4552 157.147 52.1373 155.465L49.6289 158.5C49.753 159.181 49.8264 159.871 49.8484 160.563C49.8484 160.67 49.8484 160.77 49.8484 160.87L52.6766 161.767C52.6704 161.347 52.6704 160.946 52.6641 160.563Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M48.25 154.984C48.5419 155.316 48.781 155.69 48.9586 156.094L50.7082 150.845C50.2465 149.745 49.5207 148.776 48.5949 148.023L48.25 154.984Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M49.4797 163.949C49.3693 164.401 49.2139 164.84 49.0156 165.26L50.458 171.531C51.2493 170.14 51.8025 168.627 52.0947 167.053L49.4797 163.949Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M45.2488 157.272L42.7404 153.836C42.3378 155.708 42.1276 157.616 42.1133 159.53L44.9478 159.687C44.9696 158.874 45.0704 158.066 45.2488 157.272Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M46.0884 155.186C46.2585 154.924 46.4913 154.708 46.7656 154.558L46.3517 147.598C45.455 147.905 44.6397 148.783 43.9688 150.075L46.0884 155.186Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M47.7792 166.548C47.6915 166.573 47.6007 166.586 47.5095 166.585C47.2352 166.577 46.9719 166.475 46.7633 166.297L45.3711 172.305C45.6402 172.666 45.9839 172.965 46.3789 173.181C46.7738 173.398 47.2108 173.526 47.66 173.559C47.8727 173.554 48.0837 173.52 48.2871 173.458L47.7792 166.548Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M45.2274 163.117L42.418 164.327C42.6613 166.126 43.1224 167.889 43.7913 169.576L45.5911 164.403C45.4395 163.983 45.318 163.554 45.2274 163.117Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M218.872 37.388L207.12 43.5399L192.108 45.7096C192.108 45.7096 187.411 50.231 193.92 58.5464C200.429 66.8618 205.308 69.5771 207.484 69.5771C209.66 69.5771 219.399 66.1406 221.042 65.0557C222.685 63.9708 234.424 55.2917 234.424 55.2917C234.424 55.2917 239.861 58.9101 248.014 52.9401C256.166 46.9701 277.488 29.2545 277.488 29.2545C277.488 29.2545 280.56 27.2603 278.573 23.2844C276.585 19.3086 270.972 15.3265 266.996 13.8779C263.02 12.4293 257.772 14.2416 256.335 14.9628C254.899 15.684 223.419 30.3393 223.419 30.3393C223.419 30.3393 217.787 32.3273 218.872 37.388Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M246.039 50.2812C246.016 51.3187 245.708 52.3298 245.148 53.2035"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M224.879 30.7539C224.879 30.7539 233.915 31.0549 240.08 38.2039C243.04 41.6467 244.764 44.5815 245.542 47.0209"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M220.309 36.619L225.081 34.9258C225.081 34.9258 231.634 35.3271 235.905 39.4974C240.175 43.6676 240.376 48.6405 239.981 50.2271L235.51 54.1026"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M210.176 44.2695C210.176 44.2695 218.146 49.3679 220.805 51.7195C222.724 53.4127 222.498 59.5646 222.498 59.5646"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M192.295 47.782C192.072 47.9781 191.893 48.2181 191.768 48.4868C191.643 48.7555 191.574 49.0472 191.567 49.3435C191.543 51.6811 192.085 53.9898 193.147 56.0723C195.261 60.368 204.605 67.1909 206.041 67.7364C207.477 68.282 208.43 67.3978 208.838 65.1465C209.245 62.8952 207.176 56.7182 205.156 54.8432C204.247 54.0029 197.882 49.5316 194.966 47.5876C194.562 47.3196 194.081 47.1932 193.597 47.2284C193.114 47.2636 192.655 47.4583 192.295 47.782Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M207.703 55.7264L220.082 52.917L237.415 42.6701C237.415 42.6701 238.669 41.579 235.904 39.4845C234.683 38.4891 233.363 37.6213 231.966 36.8945L214.639 47.1288L218.765 49.9383L204.73 53.0738C205.783 53.8861 206.777 54.7725 207.703 55.7264Z"
                fill="#263238"
            />
            <path
                d="M278.554 23.2842C277.407 20.9953 275.068 18.7127 272.528 16.9066C272.114 16.8176 271.687 16.8176 271.274 16.9066C270.12 17.239 236.281 34.5721 236.281 34.5721C241.066 37.7076 244.86 45.1325 244.86 45.1325C244.86 45.1325 277.858 22.8766 278.554 23.2842Z"
                fill="#263238"
            />
            <path
                d="M158.866 55.6757C156.476 54.7538 155.918 51.449 155.918 51.449C155.918 51.449 156.84 45.7486 160.145 43.3531C163.45 40.9576 166.033 40.782 167.501 40.782C168.178 40.782 169.194 41.6662 170.103 42.6633C170.661 39.3876 170.678 36.0425 170.154 32.7613C162.578 33.0059 156.401 29.3624 143.815 28.8608C133.336 28.4531 123.472 32.4854 119.201 34.5047C119.078 35.5221 119.017 36.5463 119.02 37.5712C119.02 39.3429 119.2 41.11 119.559 42.8451C120.261 42.4125 120.995 42.0331 121.754 41.7101C123.961 40.7882 129.279 43.7294 130.025 44.2875C130.772 44.8456 132.785 49.066 132.785 49.066C132.785 49.066 130.765 52.9227 127.636 53.6627C126.731 53.8815 125.801 53.9744 124.87 53.9386C126.877 56.3866 129.318 58.4443 132.07 60.0089L132.603 59.3818C134.252 57.3626 136.992 54.0515 136.992 54.0515C136.992 54.0515 147.653 54.6033 149.127 54.6033C150.6 54.6033 151.886 56.6289 152.438 59.2C152.695 60.3977 152.952 61.3447 153.153 62.0282C156.607 60.8244 159.773 58.9128 162.446 56.4156C161.223 56.3434 160.017 56.0941 158.866 55.6757Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M144.793 4.92969C138.343 4.92969 132.039 6.84219 126.676 10.4254C121.314 14.0085 117.134 19.1014 114.666 25.06C112.198 31.0185 111.552 37.5752 112.81 43.9008C114.068 50.2264 117.174 56.0368 121.735 60.5973C126.295 65.1578 132.106 68.2635 138.431 69.5218C144.757 70.78 151.313 70.1342 157.272 67.6661C163.231 65.198 168.323 61.0184 171.907 55.6558C175.49 50.2932 177.402 43.9885 177.402 37.539C177.402 28.8905 173.967 20.5962 167.851 14.4807C161.736 8.3653 153.441 4.92969 144.793 4.92969ZM162.458 56.3897C159.115 59.525 154.997 61.7136 150.527 62.7306C146.058 63.7476 141.398 63.5565 137.027 62.1767C132.656 60.7969 128.731 58.2783 125.656 54.8796C122.58 51.481 120.465 47.3248 119.527 42.838C119.168 41.1029 118.988 39.3358 118.988 37.5641C118.985 36.5392 119.046 35.515 119.17 34.4976C119.66 30.3751 121.137 26.4316 123.476 23.0018C125.816 19.5721 128.948 16.7572 132.607 14.7959C136.266 12.8347 140.344 11.785 144.496 11.736C148.647 11.6869 152.749 12.64 156.453 14.5142C160.158 16.3884 163.355 19.1285 165.775 22.5021C168.194 25.8756 169.765 29.7831 170.352 33.8928C170.94 38.0026 170.527 42.1935 169.15 46.1099C167.772 50.0263 165.47 53.5526 162.44 56.3897H162.458Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M166.586 38.7631C166.889 36.611 166.553 34.4173 165.62 32.4545C159.788 31.6204 153.83 29.2249 143.784 28.8298C135.952 28.5225 128.47 30.7111 123.403 32.6677C122.646 33.4334 122.012 34.3112 121.522 35.2702C120.782 36.9257 121.704 39.4968 121.704 39.4968L142.48 39.8668L166.586 38.7631Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M132.934 31.2248C132.934 31.2248 130.727 31.9585 131.096 37.107C131.466 42.2555 134.589 48.5077 136.797 49.9751C139.004 51.4425 146.724 52.1825 149.113 50.527C151.502 48.8714 154.632 36.9251 154.262 34.1659C153.892 31.4066 152.424 31.0304 150.587 30.6729C145.295 29.7968 139.9 29.7333 134.589 30.4848C133.982 30.5825 133.412 30.8377 132.934 31.2248Z"
                fill="#CFCFCF"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M163.982 35.0807C163.982 36.4039 162.628 37.4699 160.947 37.4699C159.266 37.4699 157.918 36.4039 157.918 35.0807C157.918 33.7575 159.273 32.6914 160.947 32.6914C162.621 32.6914 163.982 33.7638 163.982 35.0807Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M129.049 34.8699C129.224 36.1743 128.02 37.4159 126.358 37.6354C124.697 37.8549 123.223 37.0083 123.035 35.6726C122.847 34.3369 124.069 33.1203 125.725 32.9008C127.381 32.6813 128.867 33.5593 129.049 34.8699Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M58.5151 5.40019H45.7034V7.9086C39.5548 10.4472 34.298 14.7537 30.5992 20.2825C26.9003 25.8114 24.9258 32.3138 24.9258 38.9658C24.9258 45.6179 26.9003 52.1203 30.5992 57.6491C34.298 63.178 39.5548 67.4845 45.7034 70.0231V72.5315H58.5151C67.4248 72.5315 75.9695 68.9922 82.2696 62.6921C88.5696 56.392 92.109 47.8473 92.109 38.9376C92.109 30.028 88.5696 21.4832 82.2696 15.1832C75.9695 8.88309 67.4248 5.34375 58.5151 5.34375V5.40019Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M45.7033 72.5862C64.2566 72.5862 79.2971 57.5457 79.2971 38.9923C79.2971 20.4389 64.2566 5.39844 45.7033 5.39844C27.1499 5.39844 12.1094 20.4389 12.1094 38.9923C12.1094 57.5457 27.1499 72.5862 45.7033 72.5862Z"
                fill="#878787"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M45.7058 67.9819C61.717 67.9819 74.6967 55.0022 74.6967 38.9909C74.6967 22.9797 61.717 10 45.7058 10C29.6945 10 16.7148 22.9797 16.7148 38.9909C16.7148 55.0022 29.6945 67.9819 45.7058 67.9819Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M54.5084 14.7049L51.7303 27.7612C51.6796 27.997 51.7009 28.2427 51.7915 28.4664C51.882 28.69 52.0377 28.8813 52.2383 29.0154C52.4383 29.1559 52.6773 29.2305 52.9218 29.2286C53.1726 29.2273 53.4173 29.1508 53.6242 29.0091L64.5609 21.3522C61.7792 18.377 58.3352 16.0996 54.5084 14.7049ZM70.186 30.7336L58.271 36.6974C58.0517 36.8063 57.8704 36.9788 57.7508 37.1924C57.6311 37.406 57.5787 37.6508 57.6004 37.8947C57.622 38.1386 57.7168 38.3702 57.8723 38.5594C58.0277 38.7486 58.2366 38.8864 58.4717 38.9549L71.2834 42.7175C71.469 41.472 71.5612 40.2143 71.5593 38.9549C71.5466 36.1667 71.0828 33.3988 70.186 30.7587V30.7336ZM55.3174 47.3644C55.1307 47.2875 54.9283 47.2568 54.7273 47.2749C54.5263 47.293 54.3326 47.3594 54.1627 47.4683C53.9928 47.5773 53.8517 47.7256 53.7514 47.9008C53.6511 48.0759 53.5946 48.2727 53.5866 48.4743C53.5869 48.6297 53.6189 48.7833 53.6806 48.9259L58.6975 61.3049C62.2144 59.2483 65.1982 56.3934 67.4079 52.9707L55.3174 47.3644ZM45.152 51.7541C45.0904 51.5212 44.963 51.3111 44.785 51.1487C44.6071 50.9864 44.3862 50.8787 44.1487 50.8385H43.9668C43.7504 50.8393 43.538 50.8978 43.3517 51.0081C43.1654 51.1183 43.0119 51.2763 42.907 51.4656L36.3726 63.0733C40.1624 64.5393 44.2444 65.0915 48.2876 64.6849L45.152 51.7541ZM35.4947 45.1695C35.3908 44.9806 35.2384 44.8229 35.0532 44.7127C34.868 44.6024 34.6567 44.5437 34.4411 44.5424C34.3765 44.5362 34.3114 44.5362 34.2467 44.5424L21.0776 46.6996C22.2972 50.5894 24.4204 54.1351 27.2734 57.0468L35.4257 46.499C35.5658 46.3036 35.6468 46.072 35.6591 45.8318C35.6713 45.5917 35.6142 45.3531 35.4947 45.1444V45.1695ZM34.2405 33.5242L24.3072 24.5378C22.0203 27.9112 20.5693 31.7804 20.0742 35.8257L33.419 35.6313C33.6583 35.6221 33.89 35.5446 34.0867 35.4079C34.2834 35.2712 34.4369 35.0811 34.5289 34.8599C34.5858 34.7161 34.6155 34.5631 34.6167 34.4084C34.618 34.2371 34.5829 34.0674 34.5137 33.9107C34.4445 33.7539 34.3428 33.6137 34.2154 33.4991L34.2405 33.5242ZM32.2087 16.9624L40.6808 27.272C40.796 27.4104 40.9396 27.5223 41.1019 27.6002C41.2643 27.6781 41.4414 27.7202 41.6215 27.7235C41.7428 27.7232 41.8634 27.7042 41.9789 27.6671C42.2127 27.5905 42.4189 27.4468 42.5716 27.2539C42.7244 27.0609 42.817 26.8274 42.838 26.5822L43.6595 13.25C39.6016 13.5589 35.6759 14.8317 32.2087 16.9624Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M45.7057 43.2552C48.0608 43.2552 49.97 41.346 49.97 38.9909C49.97 36.6358 48.0608 34.7266 45.7057 34.7266C43.3506 34.7266 41.4414 36.6358 41.4414 38.9909C41.4414 41.346 43.3506 43.2552 45.7057 43.2552Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M39.9426 39.7193C39.9426 39.2232 39.7955 38.7383 39.5199 38.3257C39.2442 37.9132 38.8525 37.5917 38.3941 37.4019C37.9358 37.212 37.4314 37.1623 36.9448 37.2591C36.4582 37.3559 36.0113 37.5948 35.6605 37.9456C35.3097 38.2964 35.0708 38.7434 34.974 39.23C34.8772 39.7166 34.9269 40.2209 35.1167 40.6793C35.3066 41.1376 35.6281 41.5294 36.0406 41.805C36.4531 42.0806 36.9381 42.2278 37.4342 42.2278C38.0995 42.2278 38.7375 41.9635 39.2079 41.4931C39.6783 41.0226 39.9426 40.3846 39.9426 39.7193Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M44.9348 31.9264C44.9348 31.4303 44.7877 30.9453 44.512 30.5328C44.2364 30.1203 43.8447 29.7988 43.3863 29.6089C42.928 29.4191 42.4236 29.3694 41.937 29.4662C41.4504 29.563 41.0035 29.8019 40.6527 30.1527C40.3019 30.5035 40.063 30.9504 39.9662 31.437C39.8694 31.9236 39.9191 32.428 40.1089 32.8863C40.2988 33.3447 40.6203 33.7364 41.0328 34.012C41.4453 34.2877 41.9303 34.4348 42.4264 34.4348C43.0917 34.4348 43.7297 34.1705 44.2001 33.7001C44.6705 33.2297 44.9348 32.5917 44.9348 31.9264Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M54.8684 33.7545C54.8684 33.2584 54.7213 32.7734 54.4456 32.3609C54.17 31.9484 53.7783 31.6269 53.3199 31.437C52.8615 31.2472 52.3572 31.1975 51.8706 31.2943C51.384 31.3911 50.9371 31.63 50.5863 31.9808C50.2355 32.3316 49.9965 32.7786 49.8998 33.2651C49.803 33.7517 49.8526 34.2561 50.0425 34.7144C50.2324 35.1728 50.5539 35.5645 50.9664 35.8402C51.3789 36.1158 51.8639 36.2629 52.36 36.2629C53.0252 36.2629 53.6633 35.9986 54.1337 35.5282C54.6041 35.0578 54.8684 34.4198 54.8684 33.7545Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M55.2121 43.0123C55.2121 42.5162 55.065 42.0312 54.7894 41.6187C54.5138 41.2062 54.122 40.8847 53.6636 40.6948C53.2053 40.505 52.7009 40.4553 52.2144 40.5521C51.7278 40.6489 51.2808 40.8878 50.93 41.2386C50.5792 41.5894 50.3403 42.0364 50.2435 42.5229C50.1467 43.0095 50.1964 43.5139 50.3863 43.9722C50.5761 44.4306 50.8976 44.8224 51.3101 45.098C51.7226 45.3736 52.2076 45.5207 52.7037 45.5207C53.369 45.5207 54.007 45.2564 54.4774 44.786C54.9479 44.3156 55.2121 43.6776 55.2121 43.0123Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
            <path
                d="M46.802 46.6686C46.802 46.1725 46.6549 45.6875 46.3792 45.275C46.1036 44.8625 45.7118 44.541 45.2535 44.3511C44.7951 44.1612 44.2908 44.1116 43.8042 44.2084C43.3176 44.3051 42.8707 44.544 42.5199 44.8949C42.169 45.2457 41.9301 45.6926 41.8334 46.1792C41.7366 46.6658 41.7862 47.1701 41.9761 47.6285C42.166 48.0868 42.4875 48.4786 42.9 48.7542C43.3125 49.0299 43.7975 49.177 44.2936 49.177C44.9588 49.177 45.5969 48.9127 46.0673 48.4423C46.5377 47.9719 46.802 47.3338 46.802 46.6686Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.0492781"
                strokeMiterlimit="10"
            />
        </svg>
    );
};

export default Bro;
